import { MessageCircle } from "lucide-react";

export default function WhatsAppFloating() {
    return (
        <a
            href="https://wa.me/919008177176?text=Hello%20Roxy%20Cables%2C%20I%20have%20an%20enquiry."
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-floating-btn"
            aria-label="Chat with Roxy Cables on WhatsApp"
            className="group fixed bottom-5 right-5 z-40 relative w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_12px_32px_rgba(37,211,102,0.45)] hover:scale-105 transition-transform duration-300"
        >
            <MessageCircle size={24} fill="currentColor" />
            <span className="absolute -top-0.5 -right-0.5 w-3.5 h-3.5 rounded-full bg-copper animate-ping" />
            <span className="absolute -top-0.5 -right-0.5 w-3.5 h-3.5 rounded-full bg-copper" />
            <span className="hidden md:block absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-inkdark text-white font-mono text-[10px] uppercase tracking-[0.15em] px-3 py-2 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                Chat on WhatsApp
            </span>
        </a>
    );
}
